import React from 'react';
import { addDays, format } from 'date-fns';
import { InputField, SelectFieldCharterPricing } from 'components/Global';

import SelectFieldTime from 'components/Global/SelectFieldTime';
import { ReactComponent as Calendar } from 'icons/calendar-icon.svg';
import { ReactComponent as Clock } from 'icons/clock-icon.svg';
import { id } from 'date-fns/locale';

const FormComponent = ({ item, index, startDate, allRentTime }) => {
  return (
    <div key={item} className="rent-time-components__time">
      <InputField
        label={`Hari ke-${item}`}
        icon={<Calendar />}
        iconPosition={'start'}
        disable
        value={format(addDays(startDate, index), 'dd MMMM yyyy', { locale: id })}
      />

      <SelectFieldCharterPricing
        label="Durasi Sewa"
        id={`charter-pricing-${item}`}
        placeholder="Pilih Durasi Sewa"
        selectedPrice={allRentTime[index]?.charter_duration}
        disable
      />

      <SelectFieldTime
        label="Start Time"
        htmlFor={`jam-mulai-${item}`}
        placeholder="00:00"
        disable
        value={allRentTime[index]?.booking_start_time}
      />

      <InputField
        label="End Time"
        htmlFor={`jam-selesai-${item}`}
        icon={<Clock />}
        iconPosition={'start'}
        disable
        placeholder={'00:00'}
        value={allRentTime[index]?.booking_end_time}
        readOnly
      />
    </div>
  );
};

const RentTimeDetailComponents = ({ durationRent, startDate, allRentTime }) => {
  return (
    <>
      {durationRent !== 0 && (
        <div className="rent-time-components">
          {Array.from({ length: durationRent }, (_, i) => i + 1).map((item, index) => (
            <FormComponent key={item} item={item} index={index} startDate={startDate} allRentTime={allRentTime} />
          ))}
        </div>
      )}
    </>
  );
};

export default RentTimeDetailComponents;
